export const BOOKMARKSTYPES = {
  PAY: 'Pay',
  AWARD: 'Award',
  GUIDE: 'Guide',
  WEB: 'Web',
  FAVOURITES: 'Favourites',
  PAYPACT: 'Paypact',
  SHIFT: 'Shift',
  LEAVE: 'Leave',
  NOTICEREDUNDANCY: 'NoticeRedundancy',
}
